"use client";

import React from "react";
import { ScrollArea, ScrollBar } from "@/components/ui/scroll-area";
import { Separator } from "@/components/ui/separator";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
const partners = [{
  name: "Đại học Xây dựng Hà Nội",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1569116/img/logo_nuce_partner.png",
  type: "Academic"
}, {
  name: "Vinaconex",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1569116/img/logo_vinaconex_partner.png",
  type: "Construction"
}, {
  name: "Coteccons",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1569116/img/logo_coteccons_partner.png",
  type: "Construction"
}, {
  name: "Delta Group",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1569116/img/logo_delta_group.png",
  type: "Construction"
}, {
  name: "Autodesk",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1569116/img/logo_autodesk_partner.png",
  type: "Technology"
}, {
  name: "Siemens",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1569116/img/logo_siemens_partner.png",
  type: "Technology"
}, {
  name: "Hòa Bình Corp",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1569116/img/logo_hoa_binh_corp.png",
  type: "Construction"
}, {
  name: "Viettel Construction",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1569116/img/logo_viettel_construction.png",
  type: "Technology"
}];
export default function StrategicPartners() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section id="đối-tác-chiến-lược" ref={ref} className={cn("py-20 bg-background transition-opacity duration-1000", isVisible ? "opacity-100" : "opacity-0")}>
      <div className="container mx-auto px-4">
        {}
        <div className="flex flex-col items-center text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-primary tracking-tight mb-6 uppercase">
            Đối tác Chiến lược
          </h2>
          <Separator className="w-24 h-1 bg-accent rounded-full" />
          <p className="mt-6 text-muted-foreground max-w-2xl text-lg">
            Hợp tác cùng các đơn vị hàng đầu trong lĩnh vực xây dựng và công
            nghệ để kiến tạo những giá trị bền vững.
          </p>
        </div>

        {}
        <div className="relative w-full">
          <ScrollArea className="w-full whitespace-nowrap rounded-xl border border-border/40 bg-card/30 backdrop-blur-sm">
            <div className="flex w-max items-center space-x-12 p-8 md:p-12">
              {partners.map((partner, i) => <div key={i} data-index={i} className="group flex flex-col items-center justify-center gap-4 transition-all duration-300 hover:scale-105">
                  <div className="relative h-20 w-40 md:h-24 md:w-48 flex items-center justify-center overflow-hidden rounded-lg bg-white/5 p-4">
                    <img src={partner.logo} alt={partner.name} className="max-h-full max-w-full object-contain opacity-70 grayscale transition-all duration-500 group-hover:opacity-100 group-hover:grayscale-0" />
                  </div>
                  <span className="text-sm font-medium text-muted-foreground opacity-0 transition-opacity duration-300 group-hover:opacity-100">
                    {partner.name}
                  </span>
                </div>)}
            </div>
            <ScrollBar orientation="horizontal" className="bg-muted/20" />
          </ScrollArea>
          
          {}
          <div className="pointer-events-none absolute inset-y-0 left-0 w-12 bg-gradient-to-r from-background to-transparent" />
          <div className="pointer-events-none absolute inset-y-0 right-0 w-12 bg-gradient-to-l from-background to-transparent" />
        </div>
      </div>
    </section>;
}